import { createGlobalStyle } from 'styled-components';
import swiper from './swiper';
const GlobalStyle = createGlobalStyle `
  body {
    overflow-x: hidden;
  }
  
  .overflow-hidden {
    overflow: hidden;
  }

  .font-weight-400 {
    font-weight: 400;
  }

  ${swiper}
`;
export default GlobalStyle;
